module.exports = __webpack_public_path__ + "media/elo.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/elo.png
// module id = 46
// module chunks = 0